import RouteSalesTargetScreen from "../components/RouteSalesTarget/RouteSalesTargetScreen";

export default function RouteSalesTargetPage() {
  return <RouteSalesTargetScreen />;
}
